/**
 * Ctrl+M starts or stops the microphone — owner, 2026-09-06: 新增一個 hotkey … 使用 Ctrl
 * 加 M 的這一個組合,當使用者按下這一個組合之後,麥克風就可以開啟或是關閉.
 *
 * ONE document listener, CAPTURE phase, for the same reason Cmd+J and Cmd+Shift+G
 * are bound that way in App.tsx: xterm has focus most of the time and would
 * otherwise eat the chord (to xterm, Ctrl+M is a carriage return — the terminal
 * loses that spelling of Enter, which is the price of the hotkey and is stated here).
 *
 * Ctrl+M AND Cmd+M — owner, 2026-09-12: 將 Cmd + M 的快捷鍵也加入開啟/關閉麥克風的功能.
 * This file used to refuse Meta because on a Mac Cmd+M is the window's Minimise. The
 * chord is taken in the capture phase with preventDefault, which is what stops a
 * browser's own menu shortcut in Chrome and in the native shells; where a browser
 * keeps Minimise for itself regardless, Ctrl+M still works. The owner asked for both
 * knowing that.
 *
 * WHICH microphone: the most recently registered one. The composer registers on
 * mount; the Notes sheet registers on top while it is open and unregisters when it
 * closes, so the chord always reaches the microphone the person is looking at. A
 * stack rather than a single slot, so closing the sheet hands the key back rather
 * than leaving nobody listening.
 */
export const MIC_HOTKEY_LABEL = 'Ctrl+M or Cmd+M'

const stack: Array<() => void> = []
let armed = false

function isChord(e: KeyboardEvent): boolean {
  if (!(e.ctrlKey || e.metaKey) || e.altKey || e.shiftKey) return false
  // `code` is the physical key, which survives Shift and non-Latin layouts;
  // `key` covers keyboards that report no code.
  return e.code === 'KeyM' || e.key === 'm' || e.key === 'M'
}

function onKey(e: KeyboardEvent): void {
  if (!isChord(e)) return
  const top = stack[stack.length - 1]
  if (!top) return
  e.preventDefault()
  e.stopPropagation()
  top()
}

/** Make `toggle` the microphone Ctrl+M reaches until the returned function is called. */
export function registerMicHotkey(toggle: () => void): () => void {
  stack.push(toggle)
  if (!armed && typeof document !== 'undefined') {
    document.addEventListener('keydown', onKey, true)
    armed = true
  }
  return () => {
    const i = stack.lastIndexOf(toggle)
    if (i >= 0) stack.splice(i, 1)
  }
}

/** Test seam: forget every registration. */
export function __resetMicHotkey(): void {
  stack.length = 0
  if (armed && typeof document !== 'undefined') {
    document.removeEventListener('keydown', onKey, true)
    armed = false
  }
}
